import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./ProfileCards.css";

import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import LinkButton from "../Elements/LinkButton/LinkButton";

import VoucherModal from "./VoucherModal";
import WalletEditModal from "./WalletEditModal";
import TransferModal from "./TransferModal";
import WalletIdModal from "./WalletIdModal";
import TopUpModal from "./TopUpModal";

import currencyEuroIcon from "../../assets/icons/profile-page/transaction-euro.png";

const WalletSummaryCard = ({ wallet, token, userId, onRefreshData, geoCountryCode, geoReady }) => {
  const { t } = useTranslation();
  const [isIdOpen, setIsIdOpen] = useState(false);
  const [isVoucherOpen, setIsVoucherOpen] = useState(false);
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { balance, currency, id } = wallet;

  const handleOpenTransfer = () => setIsTransferOpen(true);

  const handleTransferSuccess = async () => {
    try {
      await onRefreshData();
    } catch (err) {
      console.error("Refresh failed after transfer");
    }
  };

  const handleTopUpSuccess = async () => {
    try {
      await onRefreshData();
    } catch (err) {
      console.error("TopUp refresh failed:", err);
    }
  };

  const handleWalletUpdated = async () => {
    try {
      await onRefreshData();
      setIsEditOpen(false);
    } catch (err) {
      console.error("Refresh failed after wallet update");
    }
  };

  return (
    <>
      <section className="summary-card summary-card--wallet">
        <div className="summary-wallet-top">
          <div className="summary-wallet-balance-block">
            <p className="summary-balance-label">{t("profile.walletBalance")}</p>
            <p className="summary-balance">
              {balance.toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
              {currency}
            </p>
          </div>

          <button type="button" className="summary-currency-selector" onClick={() => setIsEditOpen(true)}>
            <img src={currencyEuroIcon} alt="" className="summary-currency-selector__icon" />
            <span className="summary-currency-selector__text">{currency}</span>
          </button>
        </div>

        <LinkButton className="wallet-id-link" onClick={() => setIsVoucherOpen(true)}>
          {t("profile.gotVoucherCode")}
        </LinkButton>

        <div className="summary-actions">
          <SecondButton className="summary-btn summary-btn--primary" onClick={handleOpenTransfer}>
            {t("profile.transfer")}
          </SecondButton>
          <MainButton className="summary-btn summary-btn--primary" onClick={() => setIsTopUpOpen(true)}>
            {t("profile.topUpWallet")}
          </MainButton>
        </div>
      </section>

      {id && <WalletIdModal isOpen={isIdOpen} onClose={() => setIsIdOpen(false)} id={id} />}

      <TransferModal
        isOpen={isTransferOpen}
        onClose={() => setIsTransferOpen(false)}
        userId={userId}
        token={token}
        fromWalletId={id}
        currency={currency}
        balance={balance}
        onTransferred={handleTransferSuccess}
      />
      <TopUpModal
        isOpen={isTopUpOpen}
        onClose={() => setIsTopUpOpen(false)}
        token={token}
        walletId={id}
        currency={currency}
        onToppedUp={handleTopUpSuccess}
        geoCountryCode={geoCountryCode}
        geoReady={geoReady}
      />
      <WalletEditModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        wallet={wallet}
        token={token}
        onUpdated={handleWalletUpdated}
      />
      <VoucherModal
        isOpen={isVoucherOpen}
        onClose={() => setIsVoucherOpen(false)}
        token={token}
        walletId={id}
        currency={currency}
        onVoucherApplied={handleTopUpSuccess}
      />
    </>
  );
};

export default WalletSummaryCard;
